import {useMutation} from "@tanstack/react-query";
import {notificationsApiClient} from "@/Service/Api/V1/ApiClients/NotificationsApiClient";
import {MarkNotificationAsReadRequest} from "@/Stub/V1";
import {processRateLimiterErrors} from "@/Util/Api/processRateLimiterErrors";

export const useMarkNotificationAsRead = () => useMutation({
    mutationFn: async (request: MarkNotificationAsReadRequest) => {
        try {
            return await notificationsApiClient.markNotificationAsRead(request)
        } catch (error) {
            await processRateLimiterErrors(error);
            throw error;
        }
    },
});
